const FullScreenDialog = ({ text, onSubmit, submitText }) => {
    return (
        // Overlay background
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            {/* Dialog box */}
            <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6 mx-4 break-words">
                <h2 className="text-xl font-semibold mb-4">{text || "Completed"}</h2>

                {/* Removed form, using onClick directly */}
                <div className="flex justify-end space-x-2">
                    <button
                        type="button"
                        onClick={onSubmit}
                        className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
                    >
                        {submitText || "Ok"}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default FullScreenDialog
